import { useMemo } from "react";
import { findExactColumnIndex } from "@/lib/table-utils";

export interface SubmittalColumnMap {
  csiCode: number;
  csiTitle: number;
  submittalManager: number;
  submittalStatus: number;
  submittalType: number;
  designReviewTime: number;
  internalReviewTime: number;
  location: number;
  contractor: number;
  submittalNumber: number;
  packageTitle: number;
  packageSpecSectionNumber: number;
  packageSpecSectionDescription: number;
}

export function useSubmittalColumnMap(headers?: string[]): SubmittalColumnMap {
  return useMemo(
    () => ({
      csiCode: headers
        ? findExactColumnIndex(headers, ["CSI Code", "Submittal Spec Section Number"])
        : -1,
      csiTitle: headers
        ? findExactColumnIndex(headers, ["CSI Title", "Submittal Spec Section Description"])
        : -1,
      submittalManager: headers
        ? findExactColumnIndex(headers, ["Submittal Manager"])
        : -1,
      submittalStatus: headers
        ? findExactColumnIndex(headers, ["Submittal Status"])
        : -1,
      submittalType: headers
        ? findExactColumnIndex(headers, ["Submittal Type"])
        : -1,
      designReviewTime: headers
        ? findExactColumnIndex(headers, ["Design Team Review Time"])
        : -1,
      internalReviewTime: headers
        ? findExactColumnIndex(headers, ["Internal Review Time"])
        : -1,
      location: headers ? findExactColumnIndex(headers, ["Location"]) : -1,
      contractor: headers
        ? findExactColumnIndex(headers, ["Responsible Contractor", "Contractor"])
        : -1,
      submittalNumber: headers
        ? findExactColumnIndex(headers, ["Submittal Number"])
        : -1,
      packageTitle: headers
        ? findExactColumnIndex(headers, ["Package Title"])
        : -1,
      packageSpecSectionNumber: headers
        ? findExactColumnIndex(headers, ["Package Spec Section Number"])
        : -1,
      packageSpecSectionDescription: headers
        ? findExactColumnIndex(headers, ["Package Spec Section Description"])
        : -1,
    }),
    [headers]
  );
}
